var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGemChannelList = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4m14-1H9.333V6H20zM8 12.333a2 2 0 1 1-4 0 2 2 0 0 1 4 0m1.333 1v-2H20v2zM8 17.667a2 2 0 1 1-4 0 2 2 0 0 1 4 0m12 1H9.333v-2H20z",
  clipRule: "evenodd"
})));
export default SvgGemChannelList;